import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import { formatPhoneNumber } from "../../../../utils/Functions";
import { DeleteHospital, getRefferelBY } from "../../../../Service/partnerAPI";
import Loader from "../../../../reusableUI/loader";
import { showToast } from "../../../../reusableUI/toaster";
import { FiEdit, FiCopy } from "react-icons/fi";
import moment from "moment";
import { setPartnerVerifiedFlag } from "../visitModels/authFlags";
import {
  Select,
  Upload,
  Button,
  message,
  Space,
  Card,
  Typography,
  Modal,
} from "antd";
import {
  MdDescription,
  MdUpload,
  MdDelete,
  MdCancel,
  MdZoomIn,
  MdZoomOut,
  MdCrop,
} from "react-icons/md";
import secureLocalStorage from "react-secure-storage";
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoMdCloudUpload } from "react-icons/io";
import { getPartner, uploadMany } from "../../../../Service/partnerAPI";
import { partnerPortalEdit } from "../../../../Service/partnerAPI";
import { AiOutlineClose, AiOutlineExclamationCircle } from "react-icons/ai";
import { MdVerified } from "react-icons/md";
import { verifyIFSC, UpdateBankInfo, partnerBanner } from "../../../../Service/partnerAPI";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const { Option } = Select;
const { Dragger } = Upload;

const caseTitle = [
  { label: "Mr.", value: "Mr" },
  { label: "Ms.", value: "Ms" },
  { label: "Mrs.", value: "Mrs" },
  { label: "Dr.", value: "Dr" },
];

const caseList = [
  { label: "+91", value: "+91" },
  { label: "+1", value: "+1" },
  { label: "+44", value: "+44" },
  { label: "+971", value: "+971" },
];

const PartnerProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState();
  const [toastMsg, setToastMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reffredList, setRefferedList] = useState([]);
  const [showModel, setShowModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [copied, setCopied] = useState(false);

  const [isEditMode, setIsEditMode] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const [isContactEditMode, setIsContactEditMode] = useState(false);
  const [contactData, setContactData] = useState([
    {
      title: "",
      firstName: "",
      lastName: "",
      code: "91",
      phone: "",
      email: "",
    },
    {
      title: "",
      firstName: "",
      lastName: "",
      code: "91",
      phone: "",
      email: "",
    },
  ]);
  const originalContactData = useRef([]);

  // Bank
  const [isBankEditMode, setIsBankEditMode] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    ifscCode: "",
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
  });
  const [localBankDetails, setLocalBankDetails] = useState({
    bankName: "",
    ifscCode: "",
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
  });
  const originalBankDetails = useRef({});
  const [showAccountNumber, setShowAccountNumber] = useState(false);
  const [showConfirmAccountNumber, setShowConfirmAccountNumber] =
    useState(false);
  const [ifscError, setIfscError] = useState("");
  const [ifscVerified, setIfscVerified] = useState(false);
  const [isVerifyingIfsc, setIsVerifyingIfsc] = useState(false);
  const [isBankCompleted, setIsBankCompleted] = useState(false); // from backend

  // Address
  const [serviceRadius, setServiceRadius] = useState("");
  const [isAddressEditMode, setIsAddressEditMode] = useState(false);
  const [serviceRadiusError, setServiceRadiusError] = useState(false);

  // Documents
  const [businessLicenseFile, setBusinessLicenseFile] = useState(null);
  const [gstNumber, setGstNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [authorizedRep, setAuthorizedRep] = useState("");
  const [localGstNumber, setLocalGstNumber] = useState("");
  const [localPanNumber, setLocalPanNumber] = useState("");
  const [localAuthorizedRep, setLocalAuthorizedRep] = useState("");
  const [verificationStatus, setVerificationStatus] = useState({
    businessLicense: "notuploaded",
    gst: "notuploaded",
    pan: "notuploaded",
  });

  // Cover image (profile banner)
  const [coverImage, setCoverImage] = useState(null);
  const [tempCoverImage, setTempCoverImage] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState(null);
  const [cropPosition, setCropPosition] = useState({ x: 0, y: 0 });
  const [cropZoom, setCropZoom] = useState(1);
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    setLocalGstNumber(gstNumber);
    setLocalPanNumber(panNumber);
    setLocalAuthorizedRep(authorizedRep);
  }, [gstNumber, panNumber, authorizedRep, isEditMode]);

  const maskAccountNumber = (accountNum) => {
    if (!accountNum || accountNum.length < 4) return accountNum;
    const lastFour = accountNum.slice(-4);
    const maskedPart = "*".repeat(accountNum.length - 4);
    return maskedPart + lastFour;
  };

  const parseName = (fullName) => {
    if (!fullName) {
      return { title: "", firstName: "", lastName: "" };
    }

    const nameParts = fullName.trim().split(" ");
    const titles = ["Mr", "Ms", "Mrs", "Dr", "Mr.", "Ms.", "Mrs.", "Dr."];

    let title = "";
    let firstName = "";
    let lastName = "";

    if (nameParts.length === 0) {
      return { title: "", firstName: "", lastName: "" };
    }

    const firstPart = nameParts[0].replace(".", "");
    if (titles.includes(nameParts[0]) || titles.includes(firstPart)) {
      title = firstPart;
      if (nameParts.length > 1) {
        firstName = nameParts[1];
      }
      if (nameParts.length > 2) {
        lastName = nameParts.slice(2).join(" ");
      }
    } else {
      firstName = nameParts[0];
      if (nameParts.length > 1) {
        lastName = nameParts.slice(1).join(" ");
      }
    }

    return { title, firstName, lastName };
  };

  const parsePhone = (phoneNumber) => {
    if (!phoneNumber) {
      return { code: "+91", phone: "" };
    }

    const phoneStr = phoneNumber.toString();

    if (phoneStr.startsWith("91") && phoneStr.length > 10) {
      return { code: "+91", phone: phoneStr.slice(2) };
    } else if (phoneStr.startsWith("1") && phoneStr.length === 11) {
      return { code: "+1", phone: phoneStr.slice(1) };
    } else if (phoneStr.startsWith("44") && phoneStr.length > 10) {
      return { code: "+44", phone: phoneStr.slice(2) };
    } else if (phoneStr.startsWith("971") && phoneStr.length > 9) {
      return { code: "+971", phone: phoneStr.slice(3) };
    }

    return { code: "+91", phone: phoneStr };
  };

  const getUser = async () => {
    setLoading(true);
    try {
      const res = await getPartner();
      if (res.error === false) {
        secureLocalStorage.setItem(
          "partnerVerified",
          res.data.verified === false ? true : false
        );

        const data = res.data;
        setUser(data);

        /* ---------------- FIXED FIRST TIME CHECK ---------------- */
        const nursePricing = data?.pricingInfo?.nurseService || {};
        const physioPricing =
          data?.pricingInfo?.physioService ||
          data?.pricingInfo?.physioServices ||
          {};

        const regularSlots = Array.isArray(nursePricing?.regularShifts?.slots)
          ? nursePricing.regularShifts.slots
          : [];

        const oneTimeServices = Array.isArray(nursePricing?.oneTimeShifts?.services)
          ? nursePricing.oneTimeShifts.services
          : [];

        const physioServices = Array.isArray(physioPricing?.services)
          ? physioPricing.services
          : [];

        const physioAssessmentFees = Number(
          physioPricing?.assessmentFees ?? physioPricing?.assessmentFee ?? 0
        );

        const hasRegular = regularSlots.length > 0;
        const hasOneTime = oneTimeServices.length > 0;
        const hasPhysioServices = physioServices.length > 0;
        const hasPhysioAssessment = physioAssessmentFees > 0;

        const hasPricing =
          hasRegular ||
          hasOneTime ||
          hasPhysioServices ||
          hasPhysioAssessment;

        const isFirstTime = !hasPricing;
        setFirstTime(isFirstTime);
        /* ---------------- END FIX ---------------- */

        // Contacts
        const contacts = data?.contactInfo || [];
        const formattedContacts = [
          {
            ...parseName(contacts[0]?.name),
            ...parsePhone(contacts[0]?.phone),
            email: contacts[0]?.email || "",
          },
          contacts[1]
            ? {
              ...parseName(contacts[1]?.name),
              ...parsePhone(contacts[1]?.phone),
              email: contacts[1]?.email || "",
            }
            : {
              title: "",
              firstName: "",
              lastName: "",
              code: "91",
              phone: "",
              email: "",
            },
        ];

        setContactData(formattedContacts);
        originalContactData.current = JSON.parse(
          JSON.stringify(formattedContacts)
        );

        // Bank
        const bankInfo = data?.bankInfo || {};
        const bankData = {
          bankName: bankInfo.bankName || "",
          ifscCode: bankInfo.ifscCode || "",
          accountHolderName: bankInfo.accountHolderName || "",
          accountNumber: bankInfo.accountNumber || "",
          confirmAccountNumber: bankInfo.accountNumber || "",
        };
        setBankDetails(bankData);
        setLocalBankDetails(bankData);
        originalBankDetails.current = bankData;
        setIsBankCompleted(!!bankInfo.completed);

        setCoverImage(data?.basicInfo?.bannerImage || "");

        // Address
        setServiceRadius(data?.addressInfo?.serviceRadius?.toString() || "");

        // Documents
        const docs = data?.verificationDocuments || {};

        const getDocStatus = (doc) => {
          if (!doc || (!doc.number && !doc.docURL)) {
            return "notuploaded";
          }

          if (doc.uploadedAt) {
            if (doc.verified === "accepted") return "accepted";
            if (doc.verified === "rejected") return "rejected";
            if (doc.verified === "pending") return "pending";
          }

          return "notuploaded";
        };

        const newStatus = {
          businessLicense: getDocStatus(docs.businessLicense),
          gst: getDocStatus(docs.GST),
          pan: getDocStatus(docs.PAN),
        };

        setVerificationStatus(newStatus);
        setGstNumber(docs.GST?.number || "");
        setPanNumber(docs.PAN?.number || "");
        setAuthorizedRep(docs.authorizedRepresentative || "");

        if (docs.businessLicense?.docURL) {
          setBusinessLicenseFile({
            imageUri: docs.businessLicense.docURL,
            type: "businessLicense",
          });
        }

        const allFieldsFilled =
          docs.PAN?.number && docs.businessLicense?.docURL;

        const allPending =
          newStatus.businessLicense === "pending" &&
          newStatus.pan === "pending";

        const allAccepted =
          newStatus.businessLicense === "accepted" &&
          newStatus.pan === "accepted";

        const allRejected =
          newStatus.businessLicense === "rejected" ||
          newStatus.pan === "rejected";

        const bankDetailsFilled = data?.bankInfo?.completed;

        setShowNext(
          isFirstTime &&
          allFieldsFilled &&
          (allPending || allAccepted || allRejected) &&
          bankDetailsFilled
        );
      }
    } catch (error) {
      console.error("Error fetching user", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("user", user);


  const shouldShowEditButton = () => {
    const { businessLicense, gst, pan } = verificationStatus;

    if (
      businessLicense === "rejected" ||
      gst === "rejected" ||
      pan === "rejected"
    ) {
      return true;
    }

    if (
      businessLicense === "notuploaded" ||
      gst === "notuploaded" ||
      pan === "notuploaded"
    ) {
      return true;
    }

    if (
      businessLicense === "accepted" &&
      gst === "accepted" &&
      pan === "accepted"
    ) {
      return false;
    }
    const docs = user?.verificationDocuments || {};
    const hasBusinessUploadedAt = docs.businessLicense?.uploadedAt;
    const hasGSTUploadedAt = docs.GST?.uploadedAt;
    const hasPANUploadedAt = docs.PAN?.uploadedAt;

    if (
      businessLicense === "pending" &&
      hasBusinessUploadedAt &&
      gst === "pending" &&
      hasGSTUploadedAt &&
      pan === "pending" &&
      hasPANUploadedAt
    ) {
      return false;
    }

    return true;
  };

  const getStatusBadge = (status, type) => {
    const docs = user?.verificationDocuments || {};
    let hasUploadedAt = false;

    if (type === "businessLicense") {
      hasUploadedAt = !!docs.businessLicense?.uploadedAt;
    } else if (type === "gst") {
      hasUploadedAt = !!docs.GST?.uploadedAt;
    } else if (type === "pan") {
      hasUploadedAt = !!docs.PAN?.uploadedAt;
    }

    if (status === "accepted") {
      return (
        <div className="flex items-center gap-1 mt-2">
          <MdVerified className="text-green-500" size={16} />
          <span className="text-[11px] text-green-600 font-poppins font-medium">
            Verified
          </span>
        </div>
      );
    } else if (status === "rejected") {
      return (
        <div className="flex items-center gap-1 mt-2">
          <AiOutlineClose className="text-red-500" size={16} />
          <span className="text-[11px] text-red-600 font-poppins font-medium">
            Rejected - Re-upload required
          </span>
        </div>
      );
    } else if (status === "pending" && hasUploadedAt) {
      return (
        <div className="flex items-center gap-1 mt-2">
          <AiOutlineExclamationCircle className="text-orange-500" size={16} />
          <span className="text-[11px] text-orange-600 font-poppins font-medium">
            Pending verification
          </span>
        </div>
      );
    }
    return null;
  };

  const handleSaveDocuments = async () => {
    try {
      setLoading(true);

      const docs = user?.verificationDocuments || {};

      const needsBusinessLicense =
        verificationStatus.businessLicense === "rejected" ||
        verificationStatus.businessLicense === "notuploaded";

      const needsGST =
        verificationStatus.gst === "rejected" ||
        verificationStatus.gst === "notuploaded";

      const needsPAN =
        verificationStatus.pan === "rejected" ||
        verificationStatus.pan === "notuploaded";

      if (needsBusinessLicense && !businessLicenseFile) {
        showToast("Please upload Business License", "Warning");
        return;
      }

      if (panNumber.trim().length !== 10) {
        showToast("PAN number must be exactly 10 characters", "Warning");
        return;
      }
      // if (needsGST && !gstNumber.trim()) {
      //   showToast("Please provide GST number", "Warning");
      //   return;
      // }

      if (needsPAN && !panNumber.trim()) {
        showToast("Please provide PAN number", "Warning");
        return;
      }

      const data = {
        verificationDocuments: {
          GST: { number: gstNumber.trim() },
          PAN: { number: panNumber.trim() },
        },
      };

      if (businessLicenseFile?.imageUri instanceof File) {
        const mediaUpload = [
          {
            imageUri: businessLicenseFile.imageUri,
            type: "businessLicense",
          },
        ];

        const mediaResponse = await uploadMany(mediaUpload, user?._id, data);

        console.log("mediaResponse", mediaResponse);

        if (!mediaResponse.success) {
          const errorMsg =
            mediaResponse.error || "Failed to upload business license";
          showToast(errorMsg, "Error");
          return;
        }
      } else {
        await uploadMany([], user?._id, data);
      }

      showToast("Documents submitted for verification!", "Success");
      setIsEditMode(false);

      await getUser();
    } catch (error) {
      console.error("Error in handleSaveDocuments:", error);
      showToast("An unexpected error occurred", "Error");
    } finally {
      setLoading(false);
    }
  };

  // UPDATED: only allow PNG/JPG images, max 2 MB
  const handleFileUpload = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const isValidType = allowedTypes.includes(file.type);

    if (!isValidType) {
      showToast("You can only upload PNG or JPG image files!", "Error");
      return false;
    }

    const isValidSize = file.size / 1024 / 1024 < 2; // < 2 MB
    if (!isValidSize) {
      showToast("File must be smaller than 2MB!", "Error");
      return false;
    }

    setBusinessLicenseFile({
      imageUri: file,
      type: "businessLicense",
    });

    showToast("Business License uploaded successfully", "Success");
    return false;
  };

  // COVER IMAGE HANDLERS
  const handleCoverImageUpload = (file) => {
    const isValidType = file.type.startsWith("image/");
    if (!isValidType) {
      showToast("You can only upload image files!", "Error");
      return false;
    }

    const isValidSize = file.size / 1024 / 1024 < 5;
    if (!isValidSize) {
      showToast("Image must be smaller than 5MB!", "Error");
      return false;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setCropImageSrc(reader.result);
      setIsCropModalOpen(true);
      setCropZoom(1);
      setCropPosition({ x: 0, y: 0 });
    };
    reader.readAsDataURL(file);
    return false;
  };

  const processCroppedImage = async () => {
    if (!imageRef.current || !containerRef.current) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Fixed output resolution for cover (3:1 aspect ratio)
    canvas.width = 1200;
    canvas.height = 400;

    const img = imageRef.current;
    const container = containerRef.current;

    const viewportWidth = container.offsetWidth;
    const viewportHeight = container.offsetWidth / 3;

    const scale = img.naturalWidth / (img.offsetWidth * cropZoom);

    const visibleWidth = viewportWidth * scale;
    const visibleHeight = viewportHeight * scale;

    const cropX =
      img.naturalWidth / 2 -
      visibleWidth / 2 -
      cropPosition.x * scale;
    const cropY =
      img.naturalHeight / 2 -
      visibleHeight / 2 -
      cropPosition.y * scale;

    // Fill with dark background for areas outside the image
    ctx.fillStyle = "#1a1a2e";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Clamp source rect to image bounds
    const clampedCropX = Math.max(0, cropX);
    const clampedCropY = Math.max(0, cropY);
    const clampedCropRight = Math.min(img.naturalWidth, cropX + visibleWidth);
    const clampedCropBottom = Math.min(img.naturalHeight, cropY + visibleHeight);
    const clampedWidth = clampedCropRight - clampedCropX;
    const clampedHeight = clampedCropBottom - clampedCropY;

    // Map clamped source to destination position
    const destX = ((clampedCropX - cropX) / visibleWidth) * canvas.width;
    const destY = ((clampedCropY - cropY) / visibleHeight) * canvas.height;
    const destWidth = (clampedWidth / visibleWidth) * canvas.width;
    const destHeight = (clampedHeight / visibleHeight) * canvas.height;

    ctx.drawImage(
      img,
      clampedCropX,
      clampedCropY,
      clampedWidth,
      clampedHeight,
      destX,
      destY,
      destWidth,
      destHeight
    );

    const croppedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
    setTempCoverImage(croppedDataUrl);
    setIsCropModalOpen(false);
  };

  const handleConfirmCoverImage = async () => {
    setCoverImage(tempCoverImage);
    setTempCoverImage(null);
    let res = await partnerBanner(tempCoverImage);
    console.log("Cover picture updated successfully", res);
    if (res.error !== true) {
      // console.log("Cover picture updated successfully", res.data.data.basicInfo.bannerImage);
      // setCoverImage(res.data.data.basicInfo.bannerImage);
      await getUser();
      showToast("Cover picture updated successfully", "Success");
    } else {
      showToast("Failed to update cover picture", "Error");
    }
  };

  const handleCancelCoverImage = () => {
    setTempCoverImage(null);
  };

  const handleFileDelete = () => {
    setBusinessLicenseFile(null);
    showToast("Business License removed", "Info");
  };

  const handleEditToggle = () => {
    setIsEditMode(!isEditMode);
    if (!isEditMode) {
      setLocalGstNumber(gstNumber);
      setLocalPanNumber(panNumber);
      setLocalAuthorizedRep(authorizedRep);
    }
  };

  const handleCopy = () => {
    if (user?.referralCode) {
      navigator.clipboard.writeText(user.referralCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const handleContactEdit = () => {
    setIsContactEditMode(true);
  };

  const handleContactSave = async () => {
    try {
      const firstContact = contactData[0];

      if (
        !firstContact.firstName ||
        !firstContact.phone ||
        !firstContact.email
      ) {
        showToast(
          "Primary contact first name, phone, and email are required",
          "Error"
        );
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(firstContact.email)) {
        showToast("Please enter a valid email for primary contact", "Error");
        return;
      }

      if (firstContact.phone.length !== 10) {
        showToast("Please enter a valid 10-digit phone number", "Error");
        return;
      }

      const secondContact = contactData[1];
      const hasSecondaryData =
        secondContact.firstName ||
        secondContact.lastName ||
        secondContact.phone ||
        secondContact.email;

      if (hasSecondaryData) {
        if (
          !secondContact.firstName ||
          !secondContact.phone ||
          !secondContact.email
        ) {
          showToast(
            "All required secondary contact fields must be filled if provided",
            "Error"
          );
          return;
        }
        if (!emailRegex.test(secondContact.email)) {
          showToast(
            "Please enter a valid email for secondary contact",
            "Error"
          );
          return;
        }
        if (secondContact.phone.length !== 10) {
          showToast(
            "Please enter a valid 10-digit phone number for secondary contact",
            "Error"
          );
          return;
        }
      }

      setLoading(true);

      const contacts = [];

      contacts.push({
        name: `${firstContact.title || ""} ${firstContact.firstName || ""
          } ${firstContact.middleName || ""} ${firstContact.lastName || ""}`
          .trim()
          .replace(/\s+/g, " "),
        phone: Number(
          (firstContact.code.replace("+", "") + firstContact.phone).replace(
            /\s+/g,
            ""
          )
        ),
        email: firstContact.email,
      });

      if (
        hasSecondaryData &&
        secondContact.firstName &&
        secondContact.phone &&
        secondContact.email
      ) {
        contacts.push({
          name: `${secondContact.title || ""} ${secondContact.firstName || ""
            } ${secondContact.middleName || ""} ${secondContact.lastName || ""
            }`
            .trim()
            .replace(/\s+/g, " "),
          phone: Number(
            (secondContact.code.replace("+", "") + secondContact.phone).replace(
              /\s+/g,
              ""
            )
          ),
          email: secondContact.email,
        });
      }

      const partnerData = {
        contactInfo: contacts,
      };

      const response = await partnerPortalEdit(partnerData);

      if (response.error) {
        showToast("Failed to update contact information", "Error");
        return;
      }

      showToast("Contact information updated successfully!", "Success");

      originalContactData.current = JSON.parse(JSON.stringify(contactData));
      setIsContactEditMode(false);

      await getUser();
    } catch (error) {
      console.error("Error saving contact info:", error);
      showToast("Failed to update contact information", "Error");
    } finally {
      setLoading(false);
    }
  };

  const handleContactCancel = () => {
    setContactData(JSON.parse(JSON.stringify(originalContactData.current)));
    setIsContactEditMode(false);
  };

  const verifyIfsc = async (code) => {
    if (!code || code.length !== 11) {
      setIfscError("");
      setIfscVerified(false);
      return;
    }

    try {
      setIsVerifyingIfsc(true);
      const res = await verifyIFSC(code);

      if (!res.error && res.data) {
        const bankName =
          res.data.BANK || res.data.bank || res.data.BANKNAME || "";

        setLocalBankDetails((prev) => ({
          ...prev,
          bankName: bankName,
        }));

        setBankDetails((prev) => ({
          ...prev,
          bankName: bankName,
        }));

        setIfscError("");
        setIfscVerified(true);
      } else {
        setLocalBankDetails((prev) => ({
          ...prev,
          bankName: "",
        }));
        setIfscError("Invalid IFSC Code");
        setIfscVerified(false);
        showToast("Invalid IFSC code", "Error");
      }
    } catch (error) {
      console.error("Error verifying IFSC:", error);
      setLocalBankDetails((prev) => ({
        ...prev,
        bankName: "",
      }));
      setIfscError("Failed to verify IFSC");
      setIfscVerified(false);
      showToast("Failed to verify IFSC code", "Error");
    } finally {
      setIsVerifyingIfsc(false);
    }
  };

  const handleBankEdit = () => {
    setIsBankEditMode(true);
    setLocalBankDetails({ ...bankDetails });
    setIfscError("");
    setIfscVerified(false);
    setShowAccountNumber(false);
    setShowConfirmAccountNumber(false);
  };

  const handleBankSave = async () => {
    try {
      if (
        !localBankDetails.bankName ||
        !localBankDetails.ifscCode ||
        !localBankDetails.accountHolderName ||
        !localBankDetails.accountNumber ||
        !localBankDetails.confirmAccountNumber
      ) {
        showToast("All bank details fields are required", "Error");
        return;
      }

      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscRegex.test(localBankDetails.ifscCode)) {
        showToast("Please enter a valid IFSC code", "Error");
        return;
      }

      if (
        localBankDetails.accountNumber !==
        localBankDetails.confirmAccountNumber
      ) {
        showToast("Account numbers do not match", "Error");
        return;
      }

      if (
        localBankDetails.accountNumber.length < 9 ||
        localBankDetails.accountNumber.length > 18
      ) {
        showToast("Account number should be between 9 to 18 digits", "Error");
        return;
      }

      if (
        localBankDetails.accountHolderName.length < 3
      ) {
        showToast("Account Holder Name should be at least 3 characters", "Error");
        return;
      }

      setLoading(true);

      const data = {
        ifscCode: localBankDetails.ifscCode.trim().toUpperCase(),
        accountHolderName: localBankDetails.accountHolderName.trim(),
        accountNumber: localBankDetails.accountNumber.trim(),
      };

      const res = await UpdateBankInfo(data);

      console.log("bankinfo", res);

      if (res.error) {
        showToast("Failed to update bank details", "Error");
        return;
      }

      showToast("Bank details updated successfully!", "Success");

      setBankDetails(localBankDetails);
      originalBankDetails.current = { ...localBankDetails };
      setIsBankEditMode(false);
      setIfscError("");
      setIfscVerified(false);
      setShowAccountNumber(false);
      setShowConfirmAccountNumber(false);

      await getUser();
    } catch (error) {
      console.error("Error saving bank details:", error);
      showToast("Failed to update bank details", "Error");
    } finally {
      setLoading(false);
    }
  };

  const handleBankCancel = () => {
    setLocalBankDetails({ ...originalBankDetails.current });
    setIsBankEditMode(false);
    setIfscError("");
    setIfscVerified(false);
    setShowAccountNumber(false);
    setShowConfirmAccountNumber(false);
  };

  const updateServiceRadius = async (radiusNum) => {
    const updatedAddressInfo = {
      address1: user?.addressInfo?.address1 || "",
      address2: user?.addressInfo?.address2 || "",
      city: user?.addressInfo?.city || "",
      state: user?.addressInfo?.state || "",
      country: user?.addressInfo?.country || "India",
      pincode: user?.addressInfo?.pincode || "",
      coords: user?.addressInfo?.coords || {},
      serviceRadius: radiusNum,
      fullAddress: user?.addressInfo?.fullAddress || "",
    };

    const response = await partnerPortalEdit({
      addressInfo: updatedAddressInfo,
    });

    if (response.error) {
      showToast("Failed to update service radius", "Error");
      return false;
    }

    showToast("Service radius updated successfully!", "Success");
    return true;
  };

  const nextTrigger = () => {
    try {
      console.log("nextTrigger called");
      console.log("firstTime:", firstTime);

      // This is what makes Sidebar allow /pricing immediately
      // If you ONLY want to allow pricing at this step, keep it true.
      setPartnerVerifiedFlag(true);

      navigate("/partner/pricing", {
        state: {
          first: firstTime,
          refreshKey: Date.now(),
        },
      });
    } catch (error) {
      console.error("Error navigating to pricing:", error);
      showToast("Failed to open pricing page", "Error");
    }
  };

  const saveServiceRadius = async () => {
    const radiusNum = Number(serviceRadius);

    if (!radiusNum || radiusNum <= 0 || Number.isNaN(radiusNum)) {
      setServiceRadiusError(true);
      showToast("Please enter a valid service radius", "Error");
      return;
    }

    try {
      setLoading(true);
      const success = await updateServiceRadius(radiusNum);

      if (success) {
        setIsAddressEditMode(false);
        setServiceRadiusError(false);
        await getUser();
      }
    } catch (error) {
      console.error("Error saving service radius:", error);
      showToast("Failed to update service radius", "Error");
    } finally {
      setLoading(false);
    }
  };

  const ContactSection = ({ contact, index }) => {
    const contactType = index === 0 ? "Primary" : "Secondary";
    const fullName = `${contact.title || ""} ${contact.firstName || ""} ${contact.lastName || ""
      }`.trim();

    const [localFirstName, setLocalFirstName] = useState(contact.firstName);
    const [localLastName, setLocalLastName] = useState(contact.lastName);
    const [localPhone, setLocalPhone] = useState(contact.phone);
    const [localEmail, setLocalEmail] = useState(contact.email);

    useEffect(() => {
      setLocalFirstName(contact.firstName);
      setLocalLastName(contact.lastName);
      setLocalPhone(contact.phone);
      setLocalEmail(contact.email);
    }, [contact, isContactEditMode]);

    const updateContactData = (field, value) => {
      const updatedContacts = [...contactData];
      updatedContacts[index] = {
        ...updatedContacts[index],
        [field]: value,
      };
      setContactData(updatedContacts);
    };

    if (!isContactEditMode) {
      return (
        <div>
          <h4 className="text-[13px] font-poppins font-semibold text-gray-700 mb-3">
            {contactType} Contact
          </h4>
          <div className="bg-[#F6F8FC] shadow-sm rounded-[4px] p-4 space-y-3">
            <div className="grid grid-cols-[100px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Name</span>
              <span className="text-[#787998] font-poppins">
                : {fullName || "-"}
              </span>
            </div>
            <div className="grid grid-cols-[100px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Phone</span>
              <span className="text-[#787998] font-poppins">
                : {contact.phone ? `${contact.code} ${contact.phone}` : "-"}
              </span>
            </div>
            <div className="grid grid-cols-[100px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Email</span>
              <span className="text-[#787998] font-poppins break-all">
                : {contact.email || "-"}
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <h4 className="text-[13px] font-poppins font-semibold text-gray-700 mb-3">
          {contactType} Contact
        </h4>
        <div className="bg-blue-50 shadow-sm rounded-[4px] p-4 space-y-4">
          <div>
            <div className="flex flex-row items-center gap-14">
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Title
              </label>
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Full Name <a className="font-poppins text-[red]">*</a>
              </label>
            </div>
            <div className="flex gap-2">
              <div className="relative w-[70px]">
                <select
                  className="appearance-none w-full border border-[#D2D2D2] px-2 py-1.5 rounded-sm text-[12px] text-[#606060] font-poppins bg-white"
                  value={contact.title}
                  onChange={(e) => updateContactData("title", e.target.value)}
                >
                  <option value=""></option>
                  {caseTitle.map((item, idx) => (
                    <option key={`${item.value}-${idx}`} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-1 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-[#606060]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0l-4.25-4.66a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>

              <input
                type="text"
                className="border border-[#D2D2D2] px-2 py-1.5 rounded-sm text-[12px] font-poppins flex-1 bg-white focus:outline-none focus:border-[#4951EC]"
                placeholder="First name"
                value={localFirstName}
                onChange={(e) => setLocalFirstName(e.target.value)}
                onBlur={(e) => {
                  const val = e.target.value.trim();
                  const capitalized = val
                    ? val.charAt(0).toUpperCase() + val.slice(1)
                    : "";
                  setLocalFirstName(capitalized);
                  updateContactData("firstName", capitalized);
                }}
              />

              <input
                type="text"
                className="border border-[#D2D2D2] px-2 py-1.5 rounded-sm text-[12px] font-poppins flex-1 bg-white focus:outline-none focus:border-[#4951EC]"
                placeholder="Last name"
                value={localLastName}
                onChange={(e) => setLocalLastName(e.target.value)}
                onBlur={(e) => {
                  const val = e.target.value.trim();
                  const capitalized = val
                    ? val.charAt(0).toUpperCase() + val.slice(1)
                    : "";
                  setLocalLastName(capitalized);
                  updateContactData("lastName", capitalized);
                }}
              />
            </div>
          </div>

          <div>
            <label className="text-[13px] font-poppins text-[#606060] block mb-2">
              Phone {index === 0 && <span className="text-red-500">*</span>}
            </label>
            <div className="flex">
              <select
                className="w-[70px] border border-[#D2D2D2] px-2 py-1.5 rounded-l-sm text-[12px] text-[#606060] font-poppins bg-white focus:outline-none focus:border-[#4951EC]"
                value={contact.code}
                onChange={(e) => updateContactData("code", e.target.value)}
              >
                {caseList.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                className="border border-[#D2D2D2] px-2 py-1.5 rounded-r-sm text-[12px] font-poppins flex-1 bg-white focus:outline-none focus:border-[#4951EC]"
                maxLength={10}
                placeholder="Phone number"
                value={localPhone}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setLocalPhone(value);
                  }
                }}
                onBlur={() => updateContactData("phone", localPhone)}
              />
            </div>
          </div>

          <div>
            <label className="text-[13px] text-[#606060] block mb-2 font-poppins">
              Email {index === 0 && <span className="text-red-500">*</span>}
            </label>
            <input
              type="email"
              className="border border-[#D2D2D2] w-full px-2 py-1.5 rounded-sm text-[12px] font-poppins bg-white focus:outline-none focus:border-[#4951EC]"
              placeholder="Email address"
              value={localEmail}
              onChange={(e) => setLocalEmail(e.target.value)}
              onBlur={() => updateContactData("email", localEmail.trim())}
            />
          </div>
        </div>
      </div>
    );
  };

  const isDocumentEditable = (docType) => {
    const docs = user?.verificationDocuments || {};
    let status = verificationStatus[docType];
    let hasUploadedAt = false;

    if (docType === "businessLicense") {
      hasUploadedAt = !!docs.businessLicense?.uploadedAt;
    } else if (docType === "gst") {
      hasUploadedAt = !!docs.GST?.uploadedAt;
    } else if (docType === "pan") {
      hasUploadedAt = !!docs.PAN?.uploadedAt;
    }

    if (status === "rejected" || status === "notuploaded") {
      return true;
    }

    if (status === "accepted" || (status === "pending" && hasUploadedAt)) {
      return false;
    }

    return true;
  };

  return (
    <div className="p-2 h-[90vh] overflow-y-auto">
      {loading && <Loader />}

      <div className="bg-[#4951EC] text-white px-6 py-4 rounded-t-[14px] border border-[#9EA3FF] flex items-center">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <MdDescription size={20} className="mr-2" />
            <h2 className="text-[16px] font-poppins font-medium">
              Partner Details
            </h2>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-b-[14px] border border-[#9EA3FF] shadow-md p-2 mb-3">
        <div
          className="relative w-full mb-2 rounded-[10px] overflow-hidden group border-2 border-gray-200"
          style={{ height: "200px", backgroundColor: "#f9fafb" }}
        >
          {tempCoverImage || coverImage ? (
            <img
              src={tempCoverImage || coverImage}
              alt="Cover"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center border-2 border-dashed border-gray-300">
              <IoMdCloudUpload size={40} className="text-gray-400 mb-2" />
              <p className="text-[13px] text-gray-500 font-poppins">
                No cover picture uploaded
              </p>
            </div>
          )}


          {tempCoverImage && (
            <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center backdrop-blur-sm transition-all animate-in fade-in duration-300">
              <p className="text-white text-[14px] font-poppins font-medium mb-4">
                Confirm this image as your cover picture?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleConfirmCoverImage}
                  className="px-6 py-2 bg-green-500 text-white rounded-md text-[13px] font-poppins font-semibold hover:bg-green-600 flex items-center gap-2 shadow-lg transition-transform hover:scale-105"
                >
                  <IoCheckmarkCircle size={18} />
                  Confirm
                </button>
                <button
                  onClick={() => setIsCropModalOpen(true)}
                  className="px-6 py-2 bg-[#4951EC] text-white rounded-md text-[13px] font-poppins font-semibold hover:bg-[#3941cc] flex items-center gap-2 shadow-lg transition-transform hover:scale-105"
                >
                  <MdCrop size={18} />
                  Edit Crop
                </button>
                <button
                  onClick={handleCancelCoverImage}
                  className="px-6 py-2 bg-red-500 text-white rounded-md text-[13px] font-poppins font-semibold hover:bg-red-600 flex items-center gap-2 shadow-lg transition-transform hover:scale-105"
                >
                  <MdCancel size={18} />
                  Cancel
                </button>
              </div>
            </div>
          )}


          {!tempCoverImage && (
            <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <label className="cursor-pointer bg-white/90 hover:bg-white text-[#4951EC] px-4 py-2 rounded-md shadow-md flex items-center gap-2 text-[12px] font-poppins font-semibold border border-[#4951EC] transition-all">
                <input
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files[0] &&
                    handleCoverImageUpload(e.target.files[0])
                  }
                />
                <MdUpload size={16} />
                {coverImage ? "Change Cover" : "Upload Cover"}
              </label>
            </div>
          )}
        </div>

        <div className="px-2 mb-6">
          <p className="text-[12px] text-gray-500 font-poppins italic flex items-center gap-2">
            <AiOutlineExclamationCircle
              className="text-[#4951EC]"
              size={14}
            />
            Note: This cover picture will be visible to patients along with your
            hospital/agency name.
          </p>
        </div>


        <Modal
          title={
            <span className="font-poppins text-[16px]">
              Crop Cover Picture
            </span>
          }
          open={isCropModalOpen}
          onCancel={() => setIsCropModalOpen(false)}
          footer={[
            <Button
              key="cancel"
              onClick={() => setIsCropModalOpen(false)}
              className="font-poppins"
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={processCroppedImage}
              className="bg-[#4951EC] font-poppins"
            >
              Apply Crop
            </Button>,
          ]}
          width={800}
          centered
        >
          <div className="flex flex-col gap-6 py-4">
            <p className="text-[13px] text-gray-500 font-poppins">
              Drag the image to position it and use the slider to zoom. The
              highlighted area is your new cover picture.
            </p>

            <div
              ref={containerRef}
              className="relative w-full aspect-[3/1] bg-gray-100 rounded-lg overflow-hidden border border-gray-200 cursor-move"
              onMouseDown={(e) => {
                const startX = e.clientX - cropPosition.x;
                const startY = e.clientY - cropPosition.y;

                const handleMouseMove = (moveEvent) => {
                  setCropPosition({
                    x: moveEvent.clientX - startX,
                    y: moveEvent.clientY - startY,
                  });
                };

                const handleMouseUp = () => {
                  document.removeEventListener("mousemove", handleMouseMove);
                  document.removeEventListener("mouseup", handleMouseUp);
                };

                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
              }}
            >
              {cropImageSrc && (
                <img
                  ref={imageRef}
                  src={cropImageSrc}
                  alt="To Crop"
                  className="absolute transition-transform duration-75 select-none pointer-events-none"
                  style={{
                    transform: `translate(calc(-50% + ${cropPosition.x}px), calc(-50% + ${cropPosition.y}px)) scale(${cropZoom})`,
                    top: "50%",
                    left: "50%",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                  onLoad={() => {
                    setCropPosition({ x: 0, y: 0 });
                  }}
                />
              )}
              <div className="absolute inset-0 border-2 border-[#4951EC] pointer-events-none shadow-[0_0_0_9999px_rgba(0,0,0,0.4)]"></div>
            </div>

            <div className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg">
              <MdZoomOut size={20} className="text-gray-400" />
              <input
                type="range"
                min="1"
                max="3"
                step="0.01"
                value={cropZoom}
                onChange={(e) => setCropZoom(parseFloat(e.target.value))}
                className="flex-1 accent-[#4951EC] h-1.5 rounded-lg appearance-none cursor-pointer bg-gray-200"
              />
              <MdZoomIn size={20} className="text-gray-400" />
              <span className="text-[12px] font-poppins font-semibold text-gray-600 min-w-[40px]">
                {Math.round(cropZoom * 100)}%
              </span>
              <Button
                size="small"
                onClick={() => {
                  setCropZoom(1);
                  setCropPosition({ x: 0, y: 0 });
                }}
                className="text-[11px] font-poppins"
              >
                Reset
              </Button>
            </div>
          </div>
        </Modal>
        <div className="p-6">
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div>
              <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
                General Information
              </h3>
              <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">Name</span>
                  <span className="text-[#787998] font-poppins">
                    : {capitalizeFirstLetter(user?.basicInfo?.name)}
                  </span>
                </div>
                {user?.providerType === "individual" ? (
                  <>
                    <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                      <span className="text-gray-600 font-poppins">DOB</span>
                      <span className="text-[#787998] font-poppins">
                        :{" "}
                        {moment(user?.basicInfo?.dob).format("DD-MM-YYYY") ||
                          "N/A"}
                      </span>
                    </div>
                    <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                      <span className="text-gray-600 font-poppins">Email</span>
                      <span className="text-[#787998] font-poppins">
                        : {user?.basicInfo?.email || "N/A"}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                      <span className="text-gray-600 font-poppins">Slogan</span>
                      <span className="text-[#787998] font-poppins">
                        : {user?.basicInfo?.slogan || "N/A"}
                      </span>
                    </div>
                    <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                      <span className="text-gray-600 font-poppins">
                        No of Patients
                      </span>
                      <span className="text-[#787998] font-poppins">
                        : {user?.basicInfo?.patientCount || "N/A"}
                      </span>
                    </div>
                  </>
                )}
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">
                    Referral code
                  </span>
                  <span className="text-[#787998] font-medium font-poppins flex items-center gap-2">
                    : {user?.referralCode || "N/A"}
                    {user?.referralCode && (
                      <>
                        <button
                          onClick={handleCopy}
                          className="text-gray-500 hover:text-indigo-600 transition-colors"
                          title="Copy referral code"
                        >
                          <FiCopy size={12} />
                        </button>
                        {copied && (
                          <span className="text-[10px] text-green-600">
                            Copied!
                          </span>
                        )}
                      </>
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
                Address Details
              </h3>
              <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">
                    Address Line 1
                  </span>
                  <span className="text-[#787998] font-poppins">
                    : {user?.addressInfo?.address1 || "N/A"}
                  </span>
                </div>
                {user?.addressInfo?.address2 && (
                  <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                    <span className="text-gray-600 font-poppins">
                      Address Line 2
                    </span>
                    <span className="text-[#787998] font-poppins">
                      : {user?.addressInfo?.address2 || "N/A"}
                    </span>
                  </div>
                )}
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">City</span>
                  <span className="text-[#787998] font-poppins">
                    :{" "}
                    {capitalizeFirstLetter(user?.addressInfo?.city) || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="grid grid-cols-[60px_1fr] gap-2 text-[12px]">
                    <span className="text-gray-600 font-poppins">State</span>
                    <span className="text-[#787998] font-poppins ml-[60px]">
                      :{" "}
                      {capitalizeFirstLetter(user?.addressInfo?.state) ||
                        "N/A"}
                    </span>
                  </div>
                  <div className="grid grid-cols-[60px_1fr] gap-2 text-[12px]">
                    <span className="text-gray-600 font-poppins">
                      Pin code
                    </span>
                    <span className="text-[#787998] font-poppins">
                      : {user?.addressInfo?.pincode || "N/A"}
                    </span>
                  </div>
                </div>
                <div className="flex flex-row items-center gap-2">
                  <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px] items-center w-full">
                    <span className="text-gray-600 font-poppins">
                      Service Radius
                    </span>
                    {!isAddressEditMode ? (
                      <button
                        type="button"
                        className="text-[#787998] font-poppins flex items-center gap-1 hover:text-[#4951EC] p-0 bg-transparent border-none cursor-pointer"
                        onClick={() => {
                          setIsAddressEditMode(true);
                          setServiceRadiusError(false);
                        }}
                      >
                        <span>
                          :{" "}
                          {serviceRadius
                            ? `${serviceRadius} km`
                            : user?.addressInfo?.serviceRadius
                              ? `${user.addressInfo.serviceRadius} km`
                              : "N/A"}
                        </span>
                        <FiEdit size={14} color={"#4951EC"} />
                      </button>
                    ) : (
                      <div className="flex items-center gap-2 ml-[-10px]">
                        <span className="text-[#787998] font-poppins">:</span>
                        <input
                          type="number"
                          min={1}
                          className={`w-[80px] px-2 py-1 text-[12px] font-poppins rounded border ${serviceRadiusError
                            ? "border-red-500 bg-red-50"
                            : "border-[#D2D2D2]"
                            } focus:outline-none focus:border-[#4951EC] focus:ring-1 focus:ring-[#4951EC]`}
                          value={serviceRadius}
                          onChange={(e) => {
                            setServiceRadius(e.target.value);
                            if (serviceRadiusError)
                              setServiceRadiusError(false);
                          }}
                          placeholder="km"
                          disabled={loading}
                        />
                        <span className="text-[12px] text-[#787998] font-poppins">
                          km
                        </span>
                        <div className="flex gap-1 ml-2">
                          <button
                            onClick={saveServiceRadius}
                            disabled={loading || !serviceRadius}
                            className="px-2 py-1 bg-[#4951EC] text-white text-[11px] rounded hover:bg-[#3941cc] disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-poppins"
                          >
                            {loading ? "Saving..." : "Save"}
                          </button>
                          <button
                            onClick={() => {
                              setIsAddressEditMode(false);
                              setServiceRadiusError(false);
                              setServiceRadius(
                                user?.addressInfo?.serviceRadius?.toString() ||
                                ""
                              );
                            }}
                            disabled={loading}
                            className="px-2 py-1 border border-gray-300 text-[11px] rounded hover:bg-gray-50 disabled:opacity-50 transition-colors font-poppins"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {user?.providerType !== "individual" && (
        <div className="bg-white rounded-[14px] border border-[#9EA3FF] shadow-md p-6 mb-3">
          <div className="flex justify-between items-center mb-4 border-b pb-3 border-gray-300">
            <h3 className="text-[14px] font-poppins font-semibold text-gray-800">
              Contact Person Information
            </h3>
            {!isContactEditMode ? (
              <button
                onClick={handleContactEdit}
                className="px-4 py-1.5 border border-[#4951EC] rounded-md text-[12px] font-poppins text-[#4951EC] hover:bg-blue-50 flex items-center gap-1 transition-colors"
              >
                <FiEdit size={14} />
                Edit
              </button>
            ) : (
              <div className="flex gap-2">
                <button
                  onClick={handleContactSave}
                  disabled={loading}
                  className="px-4 py-1.5 bg-[#4951EC] text-white rounded-md text-[12px] font-poppins hover:bg-[#3941cc] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Saving..." : "Save"}
                </button>
                <button
                  onClick={handleContactCancel}
                  disabled={loading}
                  className="px-4 py-1.5 border border-gray-300 rounded-md text-[12px] font-poppins text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
                >
                  Cancel
                </button>
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-6">
            <ContactSection contact={contactData[0]} index={0} />
            <ContactSection contact={contactData[1]} index={1} />
          </div>
        </div>
      )}

      {user?.providerType !== "individual" && (
        <div className="bg-white rounded-[14px] border border-[#9EA3FF] shadow-md p-6 mb-3">
          <div className="flex justify-between items-center mb-4 border-b pb-3 border-gray-300">
            <h3 className="text-[14px] font-poppins font-semibold text-gray-800">
              Bank Details Information
            </h3>
            <div className="flex items-center gap-2">
              {!isBankEditMode ? (
                <button
                  onClick={handleBankEdit}
                  className="px-4 py-1.5 border border-[#4951EC] rounded-md text-[12px] font-poppins text-[#4951EC] hover:bg-blue-50 flex items-center gap-1 transition-colors"
                >
                  <FiEdit size={14} />
                  Edit
                </button>
              ) : (
                <div className="flex gap-2">
                  <button
                    onClick={handleBankSave}
                    disabled={loading}
                    className="px-4 py-1.5 bg-[#4951EC] text-white rounded-md text-[12px] font-poppins hover:bg-[#3941cc] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                  <button
                    onClick={handleBankCancel}
                    disabled={loading}
                    className="px-4 py-1.5 border border-gray-300 rounded-md text-[12px] font-poppins text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>

          {isBankCompleted && !isBankEditMode && (
            <div className="w-full flex justify-center mb-4">
              <div className="flex flex-col items-center gap-1 text-center">
                <MdVerified className="text-green-500" size={28} />
                <p className="text-[14px] font-poppins font-semibold text-gray-800">
                  Bank details are verified
                </p>
                <p className="text-[12px] font-poppins text-gray-500 max-w-xs">
                  Your bank information has been successfully verified. You can
                  still edit your bank details anytime using the Edit button if
                  something changes.
                </p>
              </div>
            </div>
          )}

          {!isBankEditMode ? (
            <>
              {!isBankCompleted && (
                <div className="space-y-4">
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="text-[12px] text-gray-600 font-poppins block mb-2">
                        IFSC Code
                      </label>
                      <div className="bg-[#F6F8FC] rounded-sm px-3 py-2 h-[36px] flex items-center">
                        <p className="text-[13px] text-[#787998] font-poppins font-mono">
                          {bankDetails.ifscCode || "-"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <label className="text-[12px] text-gray-600 font-poppins block mb-2">
                        Bank Name
                      </label>
                      <div className="bg-[#F6F8FC] rounded-sm px-3 py-2 h-[36px] flex items-center">
                        <p className="text-[13px] text-[#787998] font-poppins">
                          {bankDetails.bankName || "-"}
                        </p>
                      </div>
                    </div>



                    <div>
                      <label className="text-[12px] text-gray-600 font-poppins block mb-2">
                        Account Holder Name
                      </label>
                      <div className="bg-[#F6F8FC] rounded-sm px-3 py-2 h-[36px] flex items-center">
                        <p className="text-[13px] text-[#787998] font-poppins">
                          {bankDetails.accountHolderName || "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="text-[12px] text-gray-600 font-poppins block mb-2">
                        Account Number
                      </label>
                      <div className="bg-[#F6F8FC] rounded-sm px-3 py-2 h-[36px] flex items-center justify-between">
                        <p className="text-[13px] text-[#787998] font-poppins font-mono">
                          {bankDetails.accountNumber
                            ? showAccountNumber
                              ? bankDetails.accountNumber
                              : maskAccountNumber(bankDetails.accountNumber)
                            : "-"}
                        </p>
                        {bankDetails.accountNumber && (
                          <button
                            onClick={() =>
                              setShowAccountNumber(!showAccountNumber)
                            }
                            className="ml-2 text-gray-500 hover:text-[#4951EC] transition-colors"
                            title={
                              showAccountNumber
                                ? "Hide account number"
                                : "Show account number"
                            }
                          >
                            {showAccountNumber ? (
                              <AiOutlineEyeInvisible size={18} />
                            ) : (
                              <AiOutlineEye size={18} />
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="bg-blue-50 shadow-sm rounded-[4px] p-4">
              <div className="grid grid-cols-3 gap-4 mb-4">

                <div>
                  <label className="text-[13px] font-poppins text-[#606060] block mb-2">
                    IFSC Code <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={`border ${ifscError
                      ? "border-red-500"
                      : ifscVerified
                        ? "border-green-500"
                        : "border-[#D2D2D2]"
                      } w-full px-3 py-2 h-[36px] rounded-sm text-[13px] font-poppins font-mono bg-white focus:outline-none focus:border-[#4951EC] uppercase`}
                    placeholder="Enter IFSC code"
                    maxLength={11}
                    value={localBankDetails.ifscCode}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      setLocalBankDetails({
                        ...localBankDetails,
                        ifscCode: value,
                      });

                      if (value.length < 11) {
                        setIfscError("");
                        setIfscVerified(false);
                      }

                      if (value.length === 11) {
                        verifyIfsc(value);
                      }
                    }}
                  />
                  {ifscError && (
                    <p className="text-[11px] text-red-500 font-poppins mt-1">
                      {ifscError}
                    </p>
                  )}
                  {ifscVerified && (
                    <p className="text-[11px] text-green-600 font-poppins mt-1 flex items-center gap-1">
                      <MdVerified size={12} /> IFSC verified
                    </p>
                  )}
                </div>

                <div>
                  <label className="text-[13px] font-poppins text-[#606060] block mb-2">
                    Bank Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="border border-[#D2D2D2] w-full px-3 py-2 h-[36px] rounded-sm text-[13px] font-poppins bg-white focus:outline-none focus:border-[#4951EC]"
                    placeholder="Enter bank name"
                    value={localBankDetails.bankName}
                    onChange={(e) =>
                      setLocalBankDetails({
                        ...localBankDetails,
                        bankName: e.target.value,
                      })
                    }
                  />
                  {isVerifyingIfsc && (
                    <p className="text-[11px] text-blue-600 font-poppins mt-1">
                      Fetching bank name...
                    </p>
                  )}
                  {ifscVerified && localBankDetails.bankName && (
                    <p className="text-[11px] text-green-600 font-poppins mt-1 flex items-center gap-1">
                      <MdVerified size={12} /> Auto-filled from IFSC
                    </p>
                  )}
                </div>



                <div>
                  <label className="text-[13px] font-poppins text-[#606060] block mb-2">
                    Account Holder Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className="border border-[#D2D2D2] w-full px-3 py-2 h-[36px] rounded-sm text-[13px] font-poppins bg-white focus:outline-none focus:border-[#4951EC]"
                    placeholder="Enter account holder name"
                    value={localBankDetails.accountHolderName}
                    onChange={(e) =>
                      setLocalBankDetails({
                        ...localBankDetails,
                        accountHolderName: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="text-[13px] font-poppins text-[#606060] block mb-2">
                    Account Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type={showAccountNumber ? "text" : "password"}
                      inputMode="numeric"
                      className="border border-[#D2D2D2] w-full px-3 py-2 h-[36px] pr-10 rounded-sm text-[13px] font-poppins font-mono bg-white focus:outline-none focus:border-[#4951EC]"
                      placeholder="Enter account number"
                      value={localBankDetails.accountNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setLocalBankDetails({
                          ...localBankDetails,
                          accountNumber: value,
                        });
                      }}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowAccountNumber(!showAccountNumber)
                      }
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#4951EC] transition-colors"
                      title={
                        showAccountNumber
                          ? "Hide account number"
                          : "Show account number"
                      }
                    >
                      {showAccountNumber ? (
                        <AiOutlineEyeInvisible size={18} />
                      ) : (
                        <AiOutlineEye size={18} />
                      )}
                    </button>
                  </div>
                </div>

                <div>
                  <label className="text-[13px] font-poppins text-[#606060] block mb-2">
                    Confirm Account Number{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    className={`border border-[#D2D2D2] w-full px-3 py-2 h-[36px] rounded-sm text-[13px] font-poppins font-mono bg-white focus:outline-none ${localBankDetails.confirmAccountNumber &&
                      localBankDetails.accountNumber !==
                      localBankDetails.confirmAccountNumber
                      ? "border-red-500 focus:border-red-500"
                      : "focus:border-[#4951EC]"
                      }`}
                    placeholder="Re-enter account number"
                    value={localBankDetails.confirmAccountNumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setLocalBankDetails({
                        ...localBankDetails,
                        confirmAccountNumber: value,
                      });
                    }}
                  />
                  {localBankDetails.confirmAccountNumber &&
                    localBankDetails.accountNumber !==
                    localBankDetails.confirmAccountNumber && (
                      <p className="text-[11px] text-red-500 font-poppins mt-1">
                        Account numbers do not match
                      </p>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Documents section */}
      <div className="bg-white rounded-[14px] border border-[#9EA3FF] shadow-md p-6 mb-3">
        <div className="flex justify-between items-center mb-4 border-b pb-3 border-gray-300">
          <h3 className="text-[14px] font-poppins font-semibold text-gray-800">
            Document Upload
          </h3>
          {shouldShowEditButton() && (
            <div className="flex gap-2">
              {!isEditMode ? (
                <button
                  onClick={handleEditToggle}
                  className="px-4 py-1.5 border border-[#4951EC] rounded-md text-[12px] font-poppins text-[#4951EC] hover:bg-blue-50 flex items-center gap-1 transition-colors"
                >
                  <FiEdit size={14} />
                  Edit
                </button>
              ) : (
                <>
                  <button
                    onClick={handleSaveDocuments}
                    disabled={loading}
                    className="px-4 py-1.5 bg-[#4951EC] text-white rounded-md text-[12px] font-poppins hover:bg-[#3941cc] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                  <button
                    onClick={() => {
                      setIsEditMode(false);
                      setLocalGstNumber(gstNumber);
                      setLocalPanNumber(panNumber);
                      setLocalAuthorizedRep(authorizedRep);
                    }}
                    disabled={loading}
                    className="px-4 py-1.5 border border-gray-300 rounded-md text-[12px] font-poppins text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          )}
        </div>

        {/* GST / PAN / Authorized Rep */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          {/* PAN Card Number */}
          <div className="flex flex-col">
            <label className="text-[13px] text-gray-700 font-poppins font-medium mb-2">
              PAN card Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              capitalized
              className={`border-2 rounded-[8px] h-[46px] px-3 text-[13px] font-poppins transition-all ${verificationStatus.pan === "accepted"
                ? "border-green-400 bg-green-50"
                : verificationStatus.pan === "rejected"
                  ? "border-red-400 bg-red-50"
                  : verificationStatus.pan === "pending"
                    ? "border-orange-400 bg-orange-50"
                    : "border-[#D2D2D2] bg-white"
                } ${!isEditMode || !isDocumentEditable("pan")
                  ? "opacity-60 cursor-not-allowed"
                  : ""
                }`}
              placeholder="Enter PAN number"
              value={localPanNumber}
              onChange={(e) => setLocalPanNumber(e.target.value.toUpperCase())}
              onBlur={(e) => setPanNumber(e.target.value.trim())}
              disabled={!isEditMode || !isDocumentEditable("pan")}
              maxLength={10}
            />
            {getStatusBadge(verificationStatus.pan, "pan")}
            {verificationStatus.pan === "rejected" &&
              user?.verificationDocuments?.PAN?.reason && (
                <div className="mt-2 p-2 bg-red-50 rounded-md border border-red-200">
                  <p className="text-[11px] text-red-700 font-poppins">
                    <span className="font-semibold">Rejection Reason:</span>{" "}
                    {user.verificationDocuments.PAN.reason}
                  </p>
                </div>
              )}
          </div>

          {/* GST Certificate Number */}
          <div className="flex flex-col">
            <label className="text-[13px] text-gray-700 font-poppins font-medium mb-2">
              GST Certificate Number
            </label>
            <input
              type="text"
              className={`border-2 rounded-[8px] h-[46px] px-3 text-[13px] font-poppins transition-all ${verificationStatus.gst === "accepted"
                ? "border-green-400 bg-green-50"
                : verificationStatus.gst === "rejected"
                  ? "border-red-400 bg-red-50"
                  : verificationStatus.gst === "pending"
                    ? "border-orange-400 bg-orange-50"
                    : "border-[#D2D2D2] bg-white"
                } ${!isEditMode || !isDocumentEditable("gst")
                  ? "opacity-60 cursor-not-allowed"
                  : ""
                }`}
              placeholder="Enter GST number"
              value={localGstNumber}
              onChange={(e) => setLocalGstNumber(e.target.value.toUpperCase())}
              onBlur={(e) => setGstNumber(e.target.value.trim())}
              disabled={!isEditMode || !isDocumentEditable("gst")}
              maxLength={15}
            />
            {getStatusBadge(verificationStatus.gst, "gst")}
            {verificationStatus.gst === "rejected" &&
              user?.verificationDocuments?.GST?.reason && (
                <div className="mt-2 p-2 bg-red-50 rounded-md border border-red-200">
                  <p className="text-[11px] text-red-700 font-poppins">
                    <span className="font-semibold">Rejection Reason:</span>{" "}
                    {user.verificationDocuments.GST.reason}
                  </p>
                </div>
              )}
          </div>

          {/* Authorized Representative */}
          <div className="flex flex-col">
            <label className="text-[13px] text-gray-700 font-poppins font-medium mb-2">
              Authorized Representative
            </label>
            <input
              type="text"
              className={`border-2 rounded-[8px] h-[46px] px-3 text-[13px] font-poppins transition-all ${!isEditMode
                ? "border-[#D2D2D2] bg-gray-50 opacity-60 cursor-not-allowed"
                : "border-[#D2D2D2] bg-white"
                }`}
              placeholder="Enter name"
              value={localAuthorizedRep}
              onChange={(e) => setLocalAuthorizedRep(e.target.value)}
              onBlur={(e) => setAuthorizedRep(e.target.value.trim())}
              disabled={!isEditMode}
            />
          </div>
        </div>

        {/* Business License Upload */}
        <div>
          <label className="text-[13px] text-gray-700 font-poppins font-medium mb-2 block">
            Upload Company Registration Certificate{" "}
            <span className="text-red-500">*</span>
          </label>
          <div
            className={`border-2 rounded-[8px] h-[46px] flex items-center w-[390px] justify-center transition-all cursor-pointer ${verificationStatus.businessLicense === "accepted"
              ? "border-green-400 bg-green-50"
              : verificationStatus.businessLicense === "rejected"
                ? "border-red-400 bg-red-50 hover:bg-red-100"
                : verificationStatus.businessLicense === "pending"
                  ? "border-orange-400 bg-orange-50"
                  : businessLicenseFile?.imageUri instanceof File
                    ? "border-blue-400 bg-blue-50"
                    : "border-[#4951EC] bg-white hover:bg-blue-50"
              } ${!isEditMode || !isDocumentEditable("businessLicense")
                ? "opacity-60 cursor-not-allowed"
                : ""
              }`}
          >
            {(businessLicenseFile !== null ||
              user?.verificationDocuments?.businessLicense?.docURL) &&
              (verificationStatus.businessLicense === "accepted" ||
                verificationStatus.businessLicense === "pending") ? (
              <div className="flex items-center gap-2 px-4">
                {verificationStatus.businessLicense === "accepted" ? (
                  <MdVerified className="text-green-500" size={18} />
                ) : (
                  <AiOutlineExclamationCircle
                    className="text-orange-500"
                    size={18}
                  />
                )}
                <span
                  className={`text-[12px] font-poppins font-medium ${verificationStatus.businessLicense === "accepted"
                    ? "text-green-600"
                    : "text-orange-600"
                    }`}
                >
                  {verificationStatus.businessLicense === "accepted"
                    ? "Verified"
                    : "Pending"}
                </span>
                <span className="text-[11px] text-gray-600 font-poppins ml-2 truncate max-w-[200px]">
                  {businessLicenseFile?.imageUri?.name ||
                    user?.verificationDocuments?.businessLicense?.fileName ||
                    "Document uploaded"}
                </span>
              </div>
            ) : verificationStatus.businessLicense === "rejected" ||
              businessLicenseFile?.imageUri instanceof File ? (
              <div className="flex items-center justify-between w-full px-4">
                <div className="flex items-center gap-2">
                  {businessLicenseFile?.imageUri instanceof File ? (
                    <>
                      <MdDescription className="text-blue-500" size={18} />
                      <span className="text-[12px] font-poppins font-medium text-blue-600 truncate max-w-[200px]">
                        {businessLicenseFile.imageUri.name}
                      </span>
                    </>
                  ) : (
                    <>
                      <IoMdCloudUpload size={18} color={"#EF4444"} />
                      <span className="text-[12px] font-poppins font-medium text-red-600">
                        Re-upload required
                      </span>
                    </>
                  )}
                </div>
                <label
                  className={`${!isEditMode || !isDocumentEditable("businessLicense")
                    ? "cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                >
                  <input
                    type="file"
                    className="hidden"
                    accept=".png,.jpg,.jpeg"
                    onChange={(e) =>
                      e.target.files[0] && handleFileUpload(e.target.files[0])
                    }
                    disabled={
                      !isEditMode || !isDocumentEditable("businessLicense")
                    }
                  />
                  <IoMdCloudUpload
                    size={20}
                    className={
                      businessLicenseFile?.imageUri instanceof File
                        ? "text-blue-600 hover:text-blue-800"
                        : "text-red-600 hover:text-red-800"
                    }
                  />
                </label>
              </div>
            ) : (
              <label
                className={`w-full h-full flex items-center justify-center ${!isEditMode || !isDocumentEditable("businessLicense")
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
                  }`}
              >
                <input
                  type="file"
                  className="hidden"
                  accept=".png,.jpg,.jpeg"
                  onChange={(e) =>
                    e.target.files[0] && handleFileUpload(e.target.files[0])
                  }
                  disabled={
                    !isEditMode || !isDocumentEditable("businessLicense")
                  }
                />
                <div className="flex items-center gap-2 px-4">
                  <IoMdCloudUpload size={18} color={"#4951EC"} />
                  <span className="text-[12px] font-poppins font-medium text-blue-600">
                    Click to upload
                  </span>
                </div>
              </label>
            )}
          </div>

          {/* Helper text about allowed formats & size */}
          <p className="mt-1 text-[11px] text-gray-500 font-poppins">
            Allowed formats: PNG, JPG. Max file size: 2 MB.
          </p>

          {getStatusBadge(
            verificationStatus.businessLicense,
            "businessLicense"
          )}
          {businessLicenseFile?.imageUri instanceof File && (
            <div className="flex items-center justify-between text-[11px] mt-3 p-2 bg-blue-50 rounded-md border border-blue-200">
              <div className="flex items-center gap-2">
                <MdDescription className="text-blue-500" size={16} />
                <span className="font-poppins text-gray-700 truncate max-w-[250px]">
                  {businessLicenseFile.imageUri.name}
                </span>
                <span className="text-gray-500 font-poppins">
                  ({(businessLicenseFile.imageUri.size / 1024).toFixed(2)} KB)
                </span>
              </div>
              <button
                onClick={handleFileDelete}
                className="text-red-500 hover:text-red-700 transition-colors"
                title="Remove file"
                disabled={!isEditMode}
              >
                <MdDelete size={18} />
              </button>
            </div>
          )}

          {verificationStatus.businessLicense === "rejected" &&
            user?.verificationDocuments?.businessLicense?.reason && (
              <div className="mt-2 p-2 bg-red-50 rounded-md border border-red-200">
                <p className="text-[11px] text-red-700 font-poppins">
                  <span className="font-semibold">Rejection Reason:</span>{" "}
                  {user.verificationDocuments.businessLicense.reason}
                </p>
              </div>
            )}
        </div>
      </div>

      {/* Proceed button:
          This is controlled by showNext, which already includes firstTime condition
       */}
      {showNext && (
        <div className="flex justify-end mt-4">
          <button
            onClick={nextTrigger}
            className="px-6 py-2.5 bg-[#4951EC] text-white rounded-[6px] text-[14px] font-poppins hover:bg-[#3941cc] transition-colors shadow-md"
          >
            Proceed to Next Step →
          </button>
        </div>
      )}
    </div>
  );
};

export default PartnerProfile;